import { createImmerContext } from './utils'
import errors from '../core/errors'
import fields from '../core/fields'
import menu from '../core/menu'
import user from '../core/user'
import data from '../core/data'


export const { Provider, Context } = createImmerContext(
    {
        errors: errors.initialState,
        fields: fields.initialState,
        menu: menu.initialState,
        user: user.initialState,
        data: data.initialState,
    },{
        errors: errors.actions,
        fields: fields.actions,
        menu: menu.actions,
        user: user.actions,
        data: data.actions,
    }
);
